module.exports = __webpack_public_path__ + "static/media/museum-lamp.305300eb.svg";